import React from "react";
import styles from "./GrünerSchulhof.module.css";

import img1 from "./assets/card2.1.jpg";
import img2 from "./assets/card2.2.jpg";


export const Streit = (props) => {
  return (
    <div className="wrapper">
         <section className="wrapperContent">

          <div className={styles.text}>
            <h2 className={styles.title}>Streit? Kein Problem!</h2>
            <p className={styles.text}>
            Unsere Streitschlichter helfen fair und freundlich, Konflikte zu lösen – so bleibt unsere Schule ein sicherer und respektvoller Ort für alle.
            </p>

          </div>

           <div className={styles.images}>
                <img src={img1} alt="Streit" className={styles.image} />
                <img src={img2} alt="Streit" className={styles.image} />

           </div>
     </section>

    </div>
  );
};
export default Streit;
